
// Cart Drawer qty change Started -----------------
var MIN_QTY = 4;
var MATCH_TEXT = '/ custom /';
var isApplyingLogic = false;
var lastWasAllColors = null;
var lastWasCustom = null;

function enforceMinQtyForCustomItems() {
  var cartItems = document.querySelectorAll('li.rebuy-cart__flyout-item');
  console.log('cartItems:', cartItems);
  cartItems.forEach(item => {
    var titleEl = item.querySelector('.rebuy-cart__flyout-item-variant-title');
    var qtyLabel = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
    var minusBtn = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-button:first-of-type');
    var plusBtn = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-button:last-of-type');

    if (!titleEl || !qtyLabel) return;

    var isCustom = titleEl.textContent.toLowerCase().includes(MATCH_TEXT);

    if (!isCustom) return;

    // Extract numeric quantity
    var qty = parseInt(qtyLabel.textContent.replace(/\D/g, ''), 10) || 1;
    console.log(qty);
    // Enforce minimum
    if (qty < MIN_QTY) {
      qty = MIN_QTY;
      qtyLabel.textContent = qty;
    }

    // Update minus button state
    if (minusBtn) {
      minusBtn.disabled = qty <= MIN_QTY;
      minusBtn.style.opacity = qty <= MIN_QTY ? '0.4' : '';
    }

    // Update plus button state (optional, just reset style if needed)
    if (plusBtn) plusBtn.style.opacity = '';

    // Observe quantity changes (clicks or manual edits)
    var observer = new MutationObserver(() => {
      var newQty = parseInt(qtyLabel.textContent.replace(/\D/g, ''), 10) || 1;

      if (newQty < MIN_QTY) {
        qtyLabel.textContent = MIN_QTY;
        newQty = MIN_QTY;
      }

      if (minusBtn) {
        minusBtn.disabled = newQty <= MIN_QTY;
        minusBtn.style.opacity = newQty <= MIN_QTY ? '0.4' : '';
      }
    });

    observer.observe(qtyLabel, { characterData: true, subtree: true, childList: true });
  });
}

// Initial run
setTimeout(enforceMinQtyForCustomItems, 500);

// Observe cart drawer changes (AJAX updates)
var cartDrawer = document.querySelector('.rebuy-cart__flyout');
if (cartDrawer) {
  var drawerObserver = new MutationObserver(() => {
    enforceMinQtyForCustomItems();
  });

  drawerObserver.observe(cartDrawer, { childList: true, subtree: true });
}
// Cart Drawer qty change Ended -----------------

/*********************************
 * ELEMENT SELECTORS
 *********************************/

var variantInput = document.querySelector('[name="id"]');
var variantInputParentBlock = document.querySelector('safe-sticky.product-info');

var qtyButtons = document.querySelectorAll('.quantity-selector__button');
var qtyDecrease = qtyButtons[0];
var qtyIncrease = qtyButtons[1];

var infiniteOptionsLoaded = false;
var infiniteOptionsHiddenOnce = false;
/*********************************
 * HELPER FUNCTIONS
 *********************************/
function isCustomSelected() {
  var checkedBrand = document.querySelector('.variant-picker__option input[type="radio"][data-option-position="3"]:checked');
  if (!checkedBrand) return false;

  var labelSpan = document.querySelector(`label[for="${checkedBrand.id}"] span`);
  return labelSpan?.textContent.trim().toLowerCase() === 'custom';
}

function getQty() {
  var quantityInput = document.querySelector('.quantity-selector__input[name="quantity"]');
  return parseInt(quantityInput?.value, 10) || 1;
}

function setQty(val) {
  var quantityInput = document.querySelector('.quantity-selector__input[name="quantity"]');
  if (!quantityInput) return;

  quantityInput.value = val;
  quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
  quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
}

function updateDecreaseButtonState() {
  var currentQty = getQty();
  var isCustom = isCustomSelected();
  var isAllColors = isColorAllWheel();

  var qtyDecrease = document.querySelector('.quantity-selector__button:first-of-type');
  if (!qtyDecrease) return;

  let shouldDisable = false;

  if (!isCustom && currentQty <= 1) shouldDisable = true;
  if (isCustom && !isAllColors && currentQty <= 4) shouldDisable = true;

  qtyDecrease.disabled = shouldDisable;
  qtyDecrease.style.opacity = shouldDisable ? '0.4' : '';
  qtyDecrease.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
}

function isColorAllWheel() {
  const checkedColor = document.querySelector('input[data-option-position="2"]:checked');
  if (!checkedColor) return false;

  const label = document.querySelector(`label[for="${checkedColor.id}"] .sr-only`);
  const text = label?.textContent.trim().toLowerCase();

  return text?.includes('all 15 colors');
}

// MAIN CUSTOM LOGIC
function applyCustomLogic() {
  if (isApplyingLogic) return;
  isApplyingLogic = true;
  updateNotesField();

  var isCustom = isCustomSelected();
  var isAllColors = isColorAllWheel(); // ✅ YOU WERE MISSING THIS
  var customBlock = document.querySelector('[data-block-type="@app"] #infiniteoptions-container');

  if (customBlock) {
    customBlock.style.display = isCustom ? 'block' : 'none';
  }

  var currentQty = getQty();
  /* -------- RULE 2 & 4 -------- */
  // If we JUST switched from custom → non-custom, reset to 1
  if (!isCustom && lastWasCustom === true) {
    setQty(1);
  }

  /* -------- RULE 1 -------- */
  // Custom + All Colors → if coming from normal color OR non-custom AND qty was 4 → make 1
  else if (isCustom && isAllColors) {
    if ((lastWasAllColors === false || lastWasCustom === false) && currentQty === 4) {
      setQty(1);
    }
  }

  /* -------- RULE 3 -------- */
  // Custom + Normal Colors → minimum 4
  else if (isCustom && !isAllColors) {
    if (currentQty < 4) setQty(4);
  }

  /* -------- SAVE STATE -------- */
  lastWasAllColors = isAllColors;
  lastWasCustom = isCustom;

  updateDecreaseButtonState();
  syncInfiniteOptionsProperties();

  setTimeout(() => { isApplyingLogic = false; }, 50);
}

function disablePropertyInput(input) {
  input.dataset.originalName ||= input.name; // store once
  input.removeAttribute('required');
  input.removeAttribute('name');
  input.disabled = true;
}
function setCustomMode(isCustom) {
  propertyInputs.forEach(input => {
    if (isCustom) {
      enablePropertyInput(input);
    } else {
      disablePropertyInput(input);
    }
  });
}
function syncInfiniteOptionsProperties() {
  const isCustom = isCustomSelected();
  const inputs = document.querySelectorAll('#infiniteoptions-container input');

  inputs.forEach(input => {
    // --- CUSTOM SELECTED ---
    if (isCustom) {
      // Restore name from all possible sources
      if (!input.name) {
        if (input.dataset.originalName) {
          input.name = input.dataset.originalName;
          console.log('custom-if: ', input.name);
        } else if (input.getAttribute('name-disabled')) {
          input.name = input.getAttribute('name-disabled');
          console.log('custom-else: ', input.name);
        }
      }
      input.disabled = false;
      input.removeAttribute('aria-disabled');
    }


  });
}

function bindOptionListeners() {
  // Quantity input
  var qtyInput = document.querySelector('.quantity-selector__input[name="quantity"]');
  if (qtyInput && !qtyInput.dataset.boundLogic) {
    qtyInput.addEventListener('change', () => {
      applyCustomLogic();
    });
    qtyInput.dataset.boundLogic = 'true';
  }

  // Style (Custom) radios
  document.querySelectorAll('input[data-option-position="3"]').forEach(radio => {
    if (!radio.dataset.boundLogic) {
      radio.addEventListener('change', () => {
        applyCustomLogic();
        updateNotesField();
      });
      radio.dataset.boundLogic = 'true';
    }
  });

  // Color radios
  document.querySelectorAll('input[data-option-position="2"]').forEach(radio => {
    if (!radio.dataset.boundLogic) {
      radio.addEventListener('change', () => {
        applyCustomLogic();
      });
      radio.dataset.boundLogic = 'true';
    }
  });

  // Prevent invalid decrease before it happens
  var decreaseBtn = document.querySelector('.quantity-selector__button[name="minus"], .quantity-selector__button:first-of-type');

  if (decreaseBtn && !decreaseBtn.dataset.boundLogic) {
    decreaseBtn.addEventListener('click', function(e) {
      var isCustom = isCustomSelected();
      var qty = getQty();

      // Custom + NOT All Colors → cannot go below 4
      if (isCustom && !isColorAllWheel() && qty <= 4) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    decreaseBtn.dataset.boundLogic = 'true';
  }
}

// function createNotesField() {
//   if (document.getElementById('custom-notes-field')) return;

//   var variantPickerBlock = document.querySelector('[data-block-type="variant-picker"]');
//   if (!variantPickerBlock) return;

//   var wrapper = document.createElement('div');
//   wrapper.id = 'custom-notes-field';
//   wrapper.style.marginTop = '15px';

//   wrapper.innerHTML = `
//     <label for="product-notes" style="display:block; font-weight:600; margin-bottom:6px;">
//       Notes
//     </label>
//     <textarea 
//       rows="2" 
//       cols="70"
//       id="product-notes" 
//       placeholder="Please use this to further customize your order or simply to say hi!"
//       style="width:100%; padding:10px; border:1px solid #ccc; border-radius:6px;resize: none;"
//     /></textarea>
//   `;

//   variantPickerBlock.insertAdjacentElement('afterend', wrapper);
// }

function updateNotesField() {
  var wrapper = document.getElementById('custom-notes-field');
  var input = document.getElementById('product-notes');
  if (!wrapper || !input) return;

  if (isCustomSelected()) {
    wrapper.style.display = 'none';          // Hide block
    input.removeAttribute('name');           // remove line item property
  } else {
    wrapper.style.display = 'block';         // Show block
    input.name = 'properties[Notes]';        // restore property
  }
}

/********************
 * EVENT BINDINGS
 ********************/
// Qty change event
// document.querySelector('.quantity-selector__input[name="quantity"]')?.addEventListener('change', applyCustomLogic);

// Brand selection change OR Color change
// var brandRadios = document.querySelectorAll('.variant-picker__option input[type="radio"][data-option-position="3"], .variant-picker__option input[type="radio"][data-option-position="2"]' );
// brandRadios.forEach(radio => radio.addEventListener('change', applyCustomLogic));

// Observe hidden variant input for other changes
// if (variantInput && variantInputParentBlock) {
//   var variantObserver = new MutationObserver(() => {
//     document.querySelector('.quantity-selector__input[name="quantity"]')?.addEventListener('change', applyCustomLogic);
//     var brandRadios = document.querySelectorAll('.variant-picker__option input[type="radio"][data-option-position="3"], .variant-picker__option input[type="radio"][data-option-position="2"]' );
//     brandRadios.forEach(radio => radio.addEventListener('change', applyCustomLogic));

//     applyCustomLogic();
//   });
//   variantObserver.observe(variantInputParentBlock, { attributes: false, subtree: false, childList: true });
// }

if (variantInputParentBlock) {
  var variantObserver = new MutationObserver(() => {
    
    bindOptionListeners();
    applyCustomLogic();
  });

  variantObserver.observe(variantInputParentBlock, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  
  bindOptionListeners();
  applyCustomLogic();
});



function observeInfiniteOptions() {
  if (infiniteOptionsLoaded) return;

  const containerSelector = '[data-block-type="@app"] #infiniteoptions-container';
  const ioInputLoadSelector = containerSelector + ' input[name^="properties"]';

  const observer = new MutationObserver(() => {
    const input = document.querySelector(ioInputLoadSelector);
    if (!input) return;

    infiniteOptionsLoaded = true;

    const container = document.querySelector(containerSelector);
    if (container) {
      const styleObserver = new MutationObserver((mutationsList) => {
        mutationsList.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            if (!infiniteOptionsHiddenOnce && container.style.display === 'block') {
              infiniteOptionsHiddenOnce = true;
              container.style.display = 'none';
              styleObserver.disconnect(); // run only once
            }
          }
        });
      });
      styleObserver.observe(container, {attributes: true, attributeFilter: ['style']});
      // Initial check (important)
      if ( !infiniteOptionsHiddenOnce && container.style.display === 'block' ) {
        infiniteOptionsHiddenOnce = true;
        container.style.display = 'none';
        styleObserver.disconnect();
      }
    }

    applyCustomLogic();
    observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
observeInfiniteOptions();

// Prevent the Cursor image change on clicking product main media image 
var el = document.querySelector('.product-gallery__media-list-wrapper');
el.style.pointerEvents = 'none';

document.addEventListener("DOMContentLoaded", function() {
  const qtyInput = document.querySelector('#product-form-8883372392663-template--21460583252183__main-quantity');

  if (qtyInput) {
    qtyInput.value = 50;
    qtyInput.setAttribute("min", 50);
    qtyInput.setAttribute("step", 50);
  }
});






// ---------- STYLE → PRODUCT MAP ----------
const styleUrls = {
  naked: '/products/custom-personalized-golf-ball-markers-2',
  firefly: '/products/acrylic-golf-ball-markers-firefly',
  atlas: '/products/acrylic-golf-ball-markers-atlas',
  aztec: '/products/acrylic-golf-ball-markers-aztec',
  'custom image': '/products/acrylic-golf-ball-markers-custom',
  'custom text': '/products/acrylic-golf-ball-markers-custom'
};

// ---------- STYLE → VARIANT MAP (ONLY FOR SAME PRODUCT) ----------
const styleVariants = {
  'custom text': 4480555352279,
  'custom image': 4480555319511
};

// ---------- PRODUCT CONTROL ----------
const allowedProducts = [
  'custom-personalized-golf-ball-markers-2',
  'acrylic-golf-ball-markers-firefly',
  'acrylic-golf-ball-markers-atlas',
  'acrylic-golf-ball-markers-aztec',
  'acrylic-golf-ball-markers-custom'
];

const currentProduct = window.location.pathname.replace('/products/', '');


// ---------- REDIRECT / SWITCH ----------
document.addEventListener('click', function(e) {

  if (!allowedProducts.includes(currentProduct)) return;

  const label = e.target.closest('label.block-swatch');
  if (!label) return;

  const span = label.querySelector('span');
  if (!span) return;

  const style = span.textContent.trim().toLowerCase();
  const currentPath = window.location.pathname;
  const targetUrl = styleUrls[style];

  // 👉 Redirect if different product
  if (targetUrl && !currentPath.includes(targetUrl)) {
    window.location.href = targetUrl + '?design=' + encodeURIComponent(style);
    return;
  }

  // 👉 Same product → switch variant
  if (styleVariants[style]) {
    const variantId = styleVariants[style];

    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = variantId;

      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);

    }
  }

});


// ---------- AUTO SELECT FROM URL ----------
document.addEventListener('DOMContentLoaded', function() {

  if (!allowedProducts.includes(currentProduct)) return;

  const params = new URLSearchParams(window.location.search);
  const design = params.get('design');

  if (design) {
    document.querySelectorAll('label.block-swatch').forEach(function(label) {
      const span = label.querySelector('span');
      if (!span) return;

      const text = span.textContent.trim().toLowerCase();

      if (text === design.toLowerCase()) {
        label.click();
      }
    });
  }

});


// ---------- WATCH VARIANT CHANGES (IMPACT FIX) ----------
const observer = new MutationObserver(function () {
  setQuantityIfNeeded();
});

document.addEventListener('DOMContentLoaded', function () {
  const variantInput = document.querySelector('form[action="/cart/add"] input[name="id"]');

  if (variantInput) {
    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }
});




// QTY Script

(function () {

  function getLabelText(input) {

    if (!input) return '';

    const label = document.querySelector(
      'label[for="' + input.id + '"]'
    );

    return (
      label?.innerText ||
      input.value ||
      ''
    ).trim().toLowerCase();

  }

  function triggerEvents(el) {

    el.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    el.dispatchEvent(
      new Event('change', { bubbles: true })
    );

  }

  function setQty(qtyInput, value) {

    qtyInput.value = value;

    triggerEvents(qtyInput);

  }

  let lastMode = '';

  function updateQty() {

    const qtyInput =
      document.querySelector('[name="quantity"]');

    if (!qtyInput) return;

    // STYLE
    const styleInput =
      document.querySelector('[name*="option3"]:checked');

    const style =
      getLabelText(styleInput);

    // COLOR
    const colorInput =
      document.querySelector('[name*="option2"]:checked');

    const color =
      getLabelText(colorInput);

    // LOGO OPTIONS
    let logoText = '';

    document.querySelectorAll('input:checked, select').forEach(function (el) {

      logoText += (
        ' ' +
        getLabelText(el) +
        ' ' +
        (el.name || '') +
        ' ' +
        (el.value || '')
      ).toLowerCase();

    });

    // CONDITIONS
    const isCustomStyle =
      style.includes('custom image') ||
      style.includes('custom text');

    const isAllColors =
      color.includes('all 15 colors');

    const isCustomLogo =
      logoText.includes('custom color') &&
      logoText.includes('one week');

    // =========================
    // ALL 15 COLORS
    // =========================

    if (isAllColors) {

      qtyInput.min = 1;

      // only reset ONCE when entering mode
      if (lastMode !== 'all15') {

        setQty(qtyInput, 1);

      }

      lastMode = 'all15';

      return;
    }

    // =========================
    // CUSTOM STYLE / LOGO
    // =========================

    if (isCustomStyle || isCustomLogo) {

      qtyInput.min = 4;

      if (parseInt(qtyInput.value || 0, 10) < 4) {

        setQty(qtyInput, 4);

      }

      lastMode = 'custom';

      return;
    }

    // =========================
    // NORMAL
    // =========================

    qtyInput.min = 1;

    lastMode = 'normal';

  }

  // OBSERVER
  const observer = new MutationObserver(function () {
    updateQty();
  });

  function init() {

    const target =
      document.querySelector('form[action*="/cart"]') ||
      document.body;

    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true
    });

    updateQty();

  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('change', updateQty);

})();